import { isMobile, isIos } from "./Utilities";

export const Constants = {
  MAX_HEIGHT: isMobile ? window.innerHeight : 700,
  MAX_WIDTH: isMobile ? window.innerWidth : 350,
  GAP_SIZE: Number(process.env.REACT_APP_GAP_SIZE),
  PIPE_WIDTH: Number(process.env.REACT_APP_PIPE_WIDTH),
  PIPE_GAP: Number(process.env.REACT_APP_PIPE_GAP),
  FLYER_WIDTH: Number(process.env.REACT_APP_FLYER_WIDTH),
  FLYER_HEIGHT: Number(process.env.REACT_APP_FLYER_HEIGHT),
  BARRIER_HEIGHT: Number(process.env.REACT_APP_BARRIER_HEIGHT),
  BARRIER_WIDTH: Number(process.env.REACT_APP_BARRIER_WIDTH),
  MOVEMENT_SPEED:
    isMobile && !isIos
      ? Number(process.env.REACT_APP_MOVEMENT_SPEED) / 1.5
      : Number(process.env.REACT_APP_MOVEMENT_SPEED),
  GRAVITY_SCALE: Number(process.env.REACT_APP_GRAVITY_SCALE),
  JUMP_HEIGHT: Number(process.env.REACT_APP_JUMP_HEIGHT),
  DIFFICULTY_MULTIPLIER: Number(process.env.REACT_APP_DIFFICULTY_MULTIPLIER),
};
